module.exports = __webpack_public_path__ + "static/media/4.5d2a78f0.jpg";